<template>
  <b-modal
    v-if="isI18n"
    id="operation-deactivate-modal-result"
    v-model="active"
    data-cy="operation-modal-result"
    :destroy-on-hide="false"
    aria-role="dialog"
    aria-label="Activar/Desactivar Operación"
    has-modal-card
    trap-focus
    :on-cancel="close"
    aria-modal
    width="400">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-body">
        <div class="modal-card-title modal-title">
          {{ $t('title') }}
        </div>
        <a
          class="close-modal delete"
          type="button"
          @click="close()" />
      </header>
      <section class="modal-card-body">
        <div v-if="result.error">
          <p v-if="result.error.length > 0">
            {{ $t('subtitleWithError') }}
          </p>
          <p v-else>
            {{ !operation.isActive ? $t('subtitleActivated') : $t('subtitleDeactivated') }}
          </p>
        </div>
        <ul v-for="(item, index) in result.error" :key="index" class="pb-4">
          <li id="error-detail" class="has-text-danger">
            - {{ item }}
          </li>
        </ul>
        <p class="has-text-weight-bold pb-0">
          {{ $t('operation') }}
          <span class="has-text-weight-normal">{{ operation.companyOperationId }}</span>
        </p>
        <p class="has-text-weight-bold pb-0">
          {{ $t('type') }}
          <span class="has-text-weight-normal">{{ getOperationTypeTitle() }}</span>
        </p>
        <p class="has-text-weight-bold pb-0">
          {{ $t('clientIdNumber') }}
          <span class="has-text-weight-normal">{{ operation.client ? operation.client['idNumber'] : '' }}</span>
        </p>
        <p class="has-text-weight-bold mt-4 pb-0">
          {{ !operation.isActive ? $t('operationActivated') : $t('operationDeactivated') }}
          <span id="operation-activated" class="has-text-weight-normal">{{ result.operationUpdated ? 'SI' : 'NO' }}</span>
        </p>
        <p v-if="result.disabledUser !== undefined" class="has-text-weight-bold pb-0">
          {{ !operation.isActive ? $t('userActivated') : $t('userDeactivated') }}
          <span id="user-activated" class="has-text-weight-normal">{{ result.disabledUser ? 'SI' : 'NO' }}</span>
        </p>
        <p class="has-text-weight-bold pb-0">
          {{ $t('pendingTransactions') }}
          <span id="transaction-pending" class="has-text-weight-normal">{{ result.pendingTransactions ? 'SI' : 'NO' }}</span>
        </p>
        <p class="has-text-weight-bold pb-0">
          {{ $t('walletBalance') }}
          <span id="client-balance" class="has-text-weight-normal">${{ result.clientBalance !== undefined ? result.clientBalance : 'N/A' }}</span>
        </p>
        <p v-if="result.operationUpdated === true && result.clientBalance > 0" class="has-text-weight-bold pb-0">
          {{ $t('rememberTransfer1') }}
          <span id="remember-balance">${{ result.clientBalance }} </span>
          {{ $t('rememberTransfer2') }}
        </p>
        <div class="buttons is-pulled-right pt-5">
          <b-button
            id="operation-modal-button-no"
            data-cy="operation-modal-button-no"
            class="button is-button-secondary"
            label="Ok"
            rounded
            @click="close()" />
        </div>
      </section>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    operation: {
      type: Object,
      required: true
    },
    result: {
      type: Object,
      required: true
    },
    isComponentModalActive: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return { };
  },
  computed: {
    active() {
      return this.$props.isComponentModalActive;
    },
    isI18n() { return ['br', 'cl', 'pe'].includes(this.$i18n.locale); }
  },
  methods: {
    getOperationTypeTitle() {
      return {
        MORTGAGE: `🏡 ${this.$t('mortgage')}`,
        COMPLEMENTARY: `💰 ${this.$t('complementary')}`,
        HOME_EQUITY: `🏡 ${this.$t('homeEquity')}`,
        PARKING: `🅿️ ${this.$t('parking')}`,
        SME: `🚀 ${this.$t('sme')}`
      }[this.operation.type];
    },
    close() {
      this.$emit('cancelProcess');
    }
  }
};
</script>

<style scoped>
.modal-card-body p {
  padding-bottom: 1rem;
}
.reasons-form {
  font-size: .8rem;
}
.modal-card-body {
  position: relative;
}
.modal-card-body .close-modal {
  position: absolute;
  right: 20px;
  top:20px;
  width: 40px;
}
.modal-title {
  color: #00CCD1;
  font-weight:500;
}

</style>
<i18n>
{
  "cl": {
    "title": "Atención",
    "subtitleDeactivated": "La operación ha sido desactivada correctamente.",
    "subtitleActivated": "La operación ha sido activada correctamente.",
    "subtitleWithError": "Han ocurrido uno o más errores:",
    "operation": "Operación:",
    "type": "Tipo:",
    "graceMonths": "Meses de gracia:",
    "active": "Activa",
    "inactive": "Inactiva",
    "mortgage": "Hipotecario",
    "complementary": "Complementario",
    "parking": "Estacionamiento",
    "sme": "SME",
    "homeEquity": "Hipotecario",
    "deactivateUser": "Desactivar Usuario",
    "clientIdNumber": "RUT:",
    "pickReason": "Elije un Motivo",
    "operationDeactivated": "Operación Desactivada:",
    "operationActivated": "Operación Activada:",
    "userDeactivated": "Usuario Desactivado:",
    "userActivated": "Usuario Activado:",
    "pendingTransactions": "Transacciones Pendientes:",
    "walletBalance": "Saldo Wallet Cliente:",
    "rememberTransfer1": "Recuerda que se debe transferir al cliente la suma de:",
    "rememberTransfer2": "por concepto Devolución Saldo Wallet."
  },
  "pe": {
    "title": "Atención",
    "subtitleDeactivated": "La operación ha sido desactivada correctamente.",
    "subtitleActivated": "La operación ha sido activada correctamente.",
    "subtitleWithError": "Han ocurrido uno o más errores:",
    "operation": "Operación:",
    "type": "Tipo:",
    "graceMonths": "Meses de gracia:",
    "active": "Activa",
    "inactive": "Inactiva",
    "mortgage": "Hipotecario",
    "complementary": "Complementario",
    "parking": "Estacionamiento",
    "sme": "SME",
    "homeEquity": "Hipotecario",
    "deactivateUser": "Desactivar Usuario",
    "clientIdNumber": "RUT:",
    "pickReason": "Elije un Motivo",
    "operationDeactivated": "Operación Desactivada:",
    "operationActivated": "Operación Activada:",
    "userDeactivated": "Usuario Desactivado:",
    "userActivated": "Usuario Activado:",
    "pendingTransactions": "Transacciones Pendientes:",
    "walletBalance": "Saldo Wallet Cliente:",
    "rememberTransfer1": "Recuerda que se debe transferir al cliente la suma de:",
    "rememberTransfer2": "por concepto Devolución Saldo Wallet."
  },
  "br": {
    "title": "Atenção",
    "subtitleDeactivated": "A operação foi desativada com sucesso.",
    "subtitleActivated": "A operação foi ativada com sucesso.",
    "subtitleWithError": "Ocorreram um ou mais erros:",
    "operation": "Operação",
    "type": "Tipo:",
    "graceMonths": "Meses de graça:",
    "active": "Ativo",
    "inactive": "Inativo",
    "mortgage": "Hipoteca",
    "complementary": "Complementar",
    "parking": "Estacionamento",
    "sme": "SME",
    "homeEquity": "Hipoteca",
    "complementary": "Complementar",
    "deactivateUser": "Desativar Usuário",
    "clientIdNumber": "RUT:",
    "pickReason": "Escolha um Motivo",
    "operationDeactivated": "Operação Desativada:",
    "operationActivated": "Operação Ativada:",
    "userDeactivated": "Usuário Desativado:",
    "userActivated": "Usuário Ativado:",
    "pendingTransactions": "Transações Pendentes:",
    "walletBalance": "Saldo da Wallet do Cliente:",
    "rememberTransfer1": "Lembre-se que a soma de: ",
    "rememberTransfer2": "deve ser transferida para o cliente para o conceito de Reembolso de Saldo da Wallet."
  }
}
</i18n>
